import { Component, OnInit } from '@angular/core';
import { User } from '../user/user';
import { Authenticate } from '../authenticate/authenticate';
import { Router } from '@angular/router';

import { AuthenticationService, UserService } from '../_services';
import { AppComponent } from '../app.component';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less'],
})



export class NavbarComponent implements OnInit {
  navbarOpen = false;
  currentUser: User;
  auth: Authenticate;
  returnUrl = "/login";
  ticketcount: number;
  isAdmin = false;
  userrole: string;
  isLoggedIn = false;
  showRepairReport = false; 
  showCreateDispatch = false;

  constructor(private router: Router, private authservice: AuthenticationService,
    private userService: UserService,
    private AC: AppComponent) {

    router.events.subscribe(() => {
      if (!this.AC.logged) {
        try {
          this.currentUser = this.userService.getCurrentUserFromCookie();
          this.ticketcount = this.currentUser.tickets.length;
          this.AC.logged = true;
          this.isLoggedIn = true;
          this.setMenu(this.currentUser.privilege);
        }
        catch (e) {
      }
      }
    }
    );
  }

  ngOnInit() {

    if (this.userService.getCurrentUserFromCookie() != null) {
      this.currentUser = this.userService.getCurrentUserFromCookie();
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      let role = this.auth.user.role.name;
      this.userrole = role;
    }


  }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }


  logout() {
    this.currentUser == null;
    this.authservice.logout();
    window.location.href = "/login";
  }
  nextPage() {
    this.router.navigate([this.returnUrl]);
  }



  setMenu(id: string) {
    if (id == "1") {
      this.isAdmin = true;
      this.showCreateDispatch = true;
      this.showRepairReport = true; 
    }
    if (id == "2") {
    }
    if (id == "3") {
      this.showCreateDispatch = true;
      this.showRepairReport = true; 
    }
  }

}
